import { matchPath } from 'react-router-dom'

export enum UrlSegment {
  END,
  MIDDLE,
}

/**
 * Aplikacja jest zamontowana pod basename `/et`, ale wzorce w reducerach są pisane
 * bez niego (`/company/:companyId/...`). Część nowszych wzorców ma `/et` wpisane
 * na sztywno, więc próbujemy obu wariantów ścieżki.
 */
const BASENAME = '/et'

/**
 * Wyciąga parametr z bieżącego adresu.
 *
 * Dopasowanie jest PREFIKSOWE (`end: false`). react-router 6 domyślnie wymaga
 * dopasowania całej ścieżki, więc wzorzec `/company/:companyId` nie pasował do
 * `/company/abc/administrationPanel` ani do niczego pod `/et` — helper zwracał `null`
 * przy każdym realnym adresie w aplikacji. Skutkiem było puste
 * `companySelection.selectedCompany.id` u wszystkich czytelników i puste identyfikatory
 * kierowcy, pojazdu oraz delegacji w pozostałych reducerach.
 */
export const extractUrlParam = (matchRoute: string, param: string) => {
  const pathname = window.location.pathname
  const candidates = pathname.startsWith(`${BASENAME}/`)
    ? [pathname.slice(BASENAME.length), pathname]
    : [pathname]

  for (const candidate of candidates) {
    const match = matchPath({ path: matchRoute, end: false }, candidate)
    const value = (match?.params as Record<string, string | undefined>)?.[param]
    if (value != null) return value
  }

  return null
}

export const matchUrlSegment = (
  currentLocation: string,
  url: string,
  segment?: UrlSegment,
): boolean => {
  if (currentLocation != null) {
    switch (segment) {
      case UrlSegment.END:
        return currentLocation.endsWith(url)
      case UrlSegment.MIDDLE:
        return currentLocation.indexOf(url) !== -1
    }
  }

  return false
}

export const matchMultipleUrlSegment = (
  currentLocation: string,
  urls: Array<string>,
  segment?: UrlSegment,
): boolean => {
  if (currentLocation != null) {
    switch (segment) {
      case UrlSegment.END:
        return urls.filter((u) => currentLocation.endsWith(u)).length > 0
      case UrlSegment.MIDDLE:
        return urls.filter((u) => currentLocation.indexOf(u) !== -1).length > 0
    }
  }

  return false
}
